const list = (text: string, task: boolean):string => {
  if (task) {
    return `<li>${text}</li>\n`;
  }
  return `<li>${text}</li>\n`;
};

export default list;
